import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class PowerUp extends Phaser.GameObjects.Container {
  constructor(scene, screenPlace, ref) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.displayClip = ABCyaPhaser.Images.addImage(0, 0, 'star', this);
    this.displayClip.scaleX = 0.8;
    this.displayClip.scaleY = 0.8;
    this.displayClip.alpha = 0.3;
    this.isHit = false;
    this.parentRef = ref;
    this.isActive = true;
    this.loc = screenPlace;
    this.layoutPowerUp();
    this.blink();
  }

  layoutPowerUp() {
    switch (this.loc) {
      case 'top':
        this.x = this.scene.mid.x + this.parentRef.x;
        this.y = this.displayClip.getBounds().height / 2;
        break;
      case 'right':
        this.x = this.scene.mid.x * 2 - (this.displayClip.getBounds().width / 2) - this.parentRef.x;
        this.y = this.scene.mid.y - (this.displayClip.getBounds().height / 2) + this.parentRef.y;
        break;
      case 'left':
        this.x = (this.displayClip.getBounds().width / 2) - this.parentRef.x;
        this.y = this.scene.mid.y - (this.displayClip.getBounds().height / 2) + this.parentRef.y;
        break;
      case 'bottom-left':
        this.x = (this.displayClip.getBounds().width / 2 - this.parentRef.x) / this.parentRef.scaleX;
        this.y = this.scene.mid.y * 2 - (this.displayClip.getBounds().height / 2) + this.parentRef.y;
        break;
      case 'bottom-right':
        this.x = this.scene.mid.x * 2 - (this.displayClip.getBounds().width / 2) - this.parentRef.x;
        this.y = this.scene.mid.y * 2 - (this.displayClip.getBounds().height / 2) + this.parentRef.y;
        break;
    }
  };

  blink() {
    if (this.isActive) {
      ABCyaPhaser.Tweens.addTween(this.displayClip, 500, { scaleX: .9,scaleY: .9,alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
        ABCyaPhaser.Tweens.addTween(this.displayClip, 500, { scaleX: .8,scaleY: .8,alpha: .3 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.blink();
        });
      });
    }
  };

  hit() {
    this.isHit = true;
    ABCyaPhaser.Tweens.addTween(this.displayClip, 600, { scaleX: 2.5,scaleY: 2.5,alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.cleanUp();
    });
  };

  removePowerUp() {
    ABCyaPhaser.Tweens.addTween(this.displayClip, 600, { scaleX: 0,scaleY: 0,alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.cleanUp();
    });
  };

  cleanUp() {
    this.isActive = false;
    this.scene.tweens.killTweensOf(this.displayClip);
    super.destroy();
  };
}